import { AgmodalStore, EntityV2Store,  aguserStore,  ccEmailStore,  chargesStore1,  configStore, containerStore,  entityStore, quoteDataRec, toEmailStore } from "../state/CommonState"
import { useSnapshot } from "valtio"
import Utils from "../util/Utils"
import { getSavedTC } from "../TC"
import airlineCodes from "../static-data/airlines"
import QuotationUtils from "../util/quotationUtil"
import Api from "../state/Api"
import EntityApi from "../state/entity-api"
import { loader } from "../util/loader"
import icbaselinerequestquote from "../assets/images/ic_baseline-request-quote.svg"
import containerdetail from "../assets/images/containerdetailsicon.svg";
import cargoDetail from "../assets/images/worldwide-shipping.svg";
import carbonrulefilled from "../assets/images/carbon_rule-filled.svg";
import { Headspan } from "../v3-componets/AgHeadspan"
import { Card } from "../v3-componets/AgCard"
import { ConsolidatorView } from "../v3-componets/AgConsolidatorView"
import { ContainerView } from "../v3-componets/AgContainerView"
import { CargoView } from "../v3-componets/AgCargoView"
import { QuoteDetails } from "../v3-componets/AgQuoteDetails"
import { useEffect, useLayoutEffect, useState } from 'react';
import { Columns, Col6,Col12 } from "../Controls"
import VehicleViewv3 from "../quotesv3/vehicle-view-v3"
import LCLChargesViewRequestApproval from "./lcl-charges-view-requestapproval"
import EditRequestApproveCharge from "./editrequestapprovcharge"
import { FCLChargesView } from "../rate-request/fcl-rate-request-charges"
import { editrequestapprovalStore } from "./editrequestapprovalStore"
import RoleUtils from "../util/RoleUtils"
import { PERMISSIONS_NEW } from "../util/constants"

const dt = (dt1) => {
    if (!dt1) return dt1
    if (dt1.length < 10) return dt1
    let s = dt1.split('-')
    return `${s[2]}-${s[1]}-${s[0]}`
}

export default function RequestApprovalView(props) {
    let isMailBody = props.isMailBody
    useSnapshot(configStore)
    useSnapshot(containerStore)
    useSnapshot(toEmailStore)
    useSnapshot(ccEmailStore)
    useSnapshot(aguserStore)
    const [actionmodal, setActionmodal] = useState(false)
    const [openChargeModel, setOpenChargeModel] = useState(false)
    const [actionstr, setActionStr] = useState("")
    const [remarks,setRemarks] = useState("")
    let modalClass = 'modal is-active'

  
    const [rec, setRec] = useState({})
    const [rec1, setRec1] = useState([])
    useLayoutEffect(() => {
        Api.getExchangerates()
    }, [])
    const imQuote = useSnapshot(quoteDataRec)
    let mailedOnDate = imQuote.mailedOn
    if (!mailedOnDate || mailedOnDate.length < 8) mailedOnDate = Utils.getCurrentDateString()
    const S = (props) => <strong>{props.children}</strong>
    // Saved T&C of this rate request: stored as {term, shippingType} (or plain text). Keep the ones
    // for this shipment type and render them as text, followed by the custom T&C.
    let quoteTC = getSavedTC(imQuote.shipmentType, imQuote.tc)
    let customTC = String(imQuote.customTC || '').split(/\r?\n/)
    if(imQuote.multicharge==undefined || imQuote.multicharge.length==0){
        quoteTC.map(e => customTC.push(e))
        quoteTC = customTC
    }
    let multiTC = []

    let reqdata = {}
    if(quoteDataRec.shipmentType == 'LCL'){
        let currentDate = new Date()
        let cargoReadinessDate = (quoteDataRec.cargoReadinessDate && quoteDataRec.cargoReadinessDate.length >= 10) ?
            new Date(quoteDataRec.cargoReadinessDate) : currentDate
        if (cargoReadinessDate < currentDate) cargoReadinessDate = currentDate
        if (isNaN(cargoReadinessDate)) cargoReadinessDate = currentDate
        let startDays = (quoteDataRec.portOfLoading === quoteDataRec.portOfReceipt) ? 2 : 8 // the logic in mail is >= 4/13, equivalent to this > 3/12
        let startDate = Utils.mmddyyyy(Utils.addDays(cargoReadinessDate, startDays))
        let endDate = Utils.mmddyyyy(Utils.newDate(quoteDataRec.validUpto))
        reqdata = {
            shipmentType:quoteDataRec.shipmentType,
            startDate:startDate,
            endDate:endDate
        }
    }else if(quoteDataRec.shipmentType.toLowerCase().indexOf('fcl')!=-1){
        reqdata = {
            shipmentType:"FCL"
        }
    }else{
        reqdata = {
            shipmentType:quoteDataRec.shipmentType
        }
    }
    

    if(quoteDataRec.reqdata==undefined || JSON.stringify(quoteDataRec.reqdata) != JSON.stringify(reqdata)){
        quoteDataRec.reqdata = reqdata
    }
    const getpr = (d)=>{
        let l = d
        for (let i = 0; i < aguserStore.list.length; i++) {
            let e = aguserStore.list[i]
            if(d==e['email']){
                l = `${e['firstName']} ${e['lastName']} (${e['email']})`
            }
        }
        return l
    }
    let a = {}
        a['Origin'] = imQuote.origin
        let containerlistall = []
        if(imQuote.multidest!=undefined){
            for (let i = 0; i < imQuote.multidest.length; i++) {
                if(imQuote.multidest.length==1){
                    a['Destination'] = imQuote.multidest[i].destination
                }else{
                    a['Destination'+(i+1)] = imQuote.multidest[i].destination
                }
            }
        }
        a['Cargo Readiness Date'] = dt(imQuote.cargoReadinessDate)
        if (imQuote.shipmentType.indexOf('Air') >= 0) {
            a['Airport of Receipt'] = imQuote.portOfReceipt
            a['Airport of departure'] = imQuote.portOfLoading
            a['Airport of Arrival'] = imQuote.portOfDischarge
        }else{
            a['Place of Receipt'] = imQuote.portOfReceipt
            a['Port of Loading'] = imQuote.portOfLoading
             if(imQuote.reworkingPort && imQuote.shipmentType.toLowerCase().indexOf('lcl') !== -1){
            a['Reworking'] = imQuote.reworkingPort
        }
            a['Port of Discharge'] = imQuote.portOfDischarge
        }
        a['Final Place of Delivery'] = imQuote.finalPlaceOfDelivery
        a['Customer Reference#'] = imQuote.customerReferenceNum
        if(imQuote.shipmentType.toLowerCase().indexOf('lcl') != -1){
            a['Valid Upto'] = imQuote.validUpto
        }
        a['Commodity Type'] = imQuote.commodityType
        a['Incoterms'] = imQuote.incoTerms
        a['Sales Person'] = imQuote.salesperson
        a['Hazardous'] = imQuote.hazardous
        if(imQuote.hazardous === 'Yes'){
            a['Class'] = imQuote.quoteClass
            a['Packing Group'] = imQuote.packingGroup
            a['UN Number'] = imQuote.unnumber
        }
        if(Utils.displayNonStackable(imQuote.shipmentType, imQuote.shipmentScope)){
            a['Non Stackable'] = imQuote.nonStackable
        }
        if(imQuote.shipmentType.toLowerCase().indexOf('lcl') != -1){
            a['Carrier'] = imQuote.carrier
            a['Tentative transit Time'] = imQuote.transitTime
        }
        if(!isMailBody && imQuote.procurement!=undefined && imQuote.procurement.length>0){
            if(imQuote.shipmentType.toLowerCase().indexOf('lcl') != -1){
                a['Procurement'] = getpr(imQuote.procurement)
            }
        }
        if(imQuote.shipmentType.toLowerCase().indexOf('lcl') != -1 && imQuote.chargeType!=undefined && imQuote.chargeType.trim()!=""){
            a['Charge Type'] = getpr(imQuote.chargeType)
        }
        if(imQuote.fba==undefined){
            quoteDataRec.fba = 'No'
        }
        if(imQuote.fbaOCC!=undefined){
            a["Origin Customs Clearance"] = imQuote.fbaOCC
        }else{
            a["Origin Customs Clearance"] = 'No'
        }
        if(imQuote.fbaDCC!=undefined){
            a["Destination Customs Clearance"] = imQuote.fbaDCC
        }else{
            a["Destination Customs Clearance"] = 'No'
        }
        a['FC'] = imQuote.fba
        if(imQuote.fba==='Yes' && imQuote['warehouse'] ){
            a['FC'] = `Yes ( ${imQuote['warehouse']} )` 
            // a['Warehouse'] = imQuote.warehouse
        }
        if(Utils.displayTemperatureControlled(imQuote.shipmentType)){
            a['Temperature Controlled'] = imQuote.temperatureControlled
            if (imQuote.temperatureControlled === 'Yes') {
                if (imQuote.shipmentType.toLowerCase().includes('air')) {
                    a['Minimum Temperature'] = imQuote.minTemperature
                    a['Maximum Temperature'] = imQuote.maxTemperature
                }else{
                    a['Temperature'] = imQuote.temperature
                    a['Cargo Value (USD)'] = imQuote.cargoValue
                }
            }
        }
        
        if(imQuote.cartingDetails !=undefined ){
            a['Carting Details'] = imQuote.cartingDetails
        }
        if(imQuote.agentDetails !=undefined){
            a['Agent Details'] = imQuote.agentDetails
        }
        if(imQuote.agentAddress !=undefined){
            a['Agent Address'] = imQuote.agentAddress   
        }
        if(!imQuote.opal){
            a['Origin Palletization'] = 'No'
        }else{
            a['Origin Palletization'] = 'Yes'
        }
        if(!imQuote.dpal){
            a['Destination Palletization'] = 'No'
        }else{
            a['Destination Palletization'] = 'Yes'
        }
       
        if(JSON.stringify(a)!=JSON.stringify(rec)){
            setRec(a)
        }
        if(imQuote.multicharge!=undefined && imQuote.multicharge.length>0){
            let k = []
            multiTC = []
            for (let i = 0; i < imQuote.multicharge.length; i++) {
                let customTC1 = String(imQuote.multicharge[i].customTC || '').split(/\r?\n/)
                quoteTC.map(e => customTC1.push(e))
                multiTC.push(customTC1)
                let a1 = {}
                if(imQuote.shipmentType.toLowerCase().indexOf('air') != -1){
                    let displayAirline = imQuote.multicharge[i].airline
                    if (imQuote.multicharge[i].airline) {
                        let temp = airlineCodes.filter(e => e.code == imQuote.multicharge[i].airline)
                        if (temp.length > 0) displayAirline = temp[0].name
                    }
                    a1['Airline'] = displayAirline
                }else{
                    
                    a1['Carrier'] = imQuote.multicharge[i].carrier
                }
                a1['Valid Upto'] = imQuote.multicharge[i].validUpto
                a1['Tentative transit Time'] = imQuote.multicharge[i].transitTime
                if(!isMailBody && imQuote.multicharge[i].procurement!=undefined && imQuote.multicharge[i].procurement.length>0){
                    a1['Procurement'] = getpr(imQuote.multicharge[i].procurement)
                }
                if(imQuote.shipmentType.toLowerCase().indexOf('fcl')!=-1 && imQuote.multicharge[i].destinationFreeTime!=undefined && imQuote.multicharge[i].destinationFreeTime>0){
                    a1['Destination Free Time'] = imQuote.multicharge[i].destinationFreeTime
                }
                k.push(a1)
            }
            if(JSON.stringify(k)!=JSON.stringify(rec1)){
                setRec1(k)
            }
        }
        
    useEffect(()=>{
        loader.show()
        const callback = (data)=>{
            if(JSON.stringify(data)!=JSON.stringify(entityStore.list)){
                entityStore.list = data
            }
            const callback1 = (data)=>{
                if(JSON.stringify(data)!=JSON.stringify(configStore.currencyList)){
                    configStore.currencyList = data
                }
                loader.hide()
            }
            Api.getLiveExchangerates(callback1)
        }
        EntityApi.getList(callback) 
    },[])
    const getlcv = (ob,key)=>{
        if(ob!=undefined){
            if(ob[key]!=undefined){
                return ob[key]
            }
        }
        return "-"
    }
    useEffect(()=>{      
        
    },[imQuote])
    const displayCargo4fcl = Utils.outGaugeContainerCheck(containerStore.list)

    return (
        <>
        { openChargeModel &&
                                                                                <div className='modal is-active' >
                                                                                    <div className="modal-background" ></div>
                                                                                        <div className="modal-card" onClick={(e) => { e.stopPropagation() }} style={{ borderRadius: '10px',width:"100%" }} >
                                                                                        <section className="modal-card-body">
                                                                                        <EditRequestApproveCharge setOpenChargeModel={setOpenChargeModel}/>
                                                                                        </section>
                                                                                    </div>
                                                                                </div>
                                                                            }
        {
                        actionmodal && <div className={modalClass}>
                        <div className="modal-background"></div>
                        <div className="modal-card">
                            <section className="modal-card-body" >
                                <button className="delete" style={{ float: 'right' }} onClick={() => { setActionmodal(false) }}></button>
                                 <p>
                                    Are you sure you want to {actionstr} this?
                                 </p>
                                 <p>
                                    Please confirm to proceed.
                                 </p>
                                 <textarea class={"textarea is-info"} value={remarks}   placeholder="Enter your remarks. (Optional)" rows={5} onChange={(e) => {
                                setRemarks(e.target.value)
                            }}></textarea>
                                 
                                 <hr />
                    <div style={{ display: 'flex', justifyContent: 'flex-start', gap: 10 }}>
                            <div className="control">
                                <button class="button is-danger" onClick={() => {
                                    setActionmodal(false)
                                }}>
                                    Cancel
                                </button>
                            </div>
                            <div className="control">
                                <button className="button"
                                 style={{backgroundColor: process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON, color: "#fff"}}
                                    onClick={async (e) => {
                                        setActionmodal(false)
                                        const callback = (d)=>{
                                            if(actionstr=="approve"){
                                                configStore.setModalMessage("Approved successfully.")
                                            }else{
                                                configStore.setModalMessage("Rejected successfully.")
                                            }
                                            AgmodalStore.pageVisible = false;
                                            AgmodalStore.apiCall = true;
                                            setRemarks("")
                                        }
                                        Api.setRequestapprovalstatus(imQuote.quotationNum,actionstr,{remarks:remarks},callback)
                                    }}>
                                    Confirm
                                </button>
                            </div>
                        </div>
                            </section>
                        </div>
                    </div>
                    }
            <body>
                <div>
                    <Headspan color="#555555" fontSize= "20px" fontWeight="700" data="Quotation Ref. No# " />
                    <Headspan color={process.env.REACT_APP_ENTERPRISE_COLOUR} fontSize= "20px" fontWeight="700" data={imQuote.quotationNum} />
                </div>
                <div>
                    <Headspan color="#555555" fontSize= "14px" fontWeight="600" data="Customer: " />
                    <Headspan color="#4BA7DD" fontSize= "14px" fontWeight="600" data={EntityV2Store.getEntityById(imQuote.entityId)} />
                    <Headspan color={process.env.REACT_APP_ENTERPRISE_COLOUR} fontSize= "30px" fontWeight="900" data=" . " />
                    <Headspan color="#555555" fontSize= "14px" fontWeight="600" data="Quote Date: " />
                    <Headspan color="#4BA7DD" fontSize= "14px" fontWeight="600" data={dt(mailedOnDate)}/>
                    <Headspan color={process.env.REACT_APP_ENTERPRISE_COLOUR} fontSize= "30px" fontWeight="900" data=" . " />
                    <Headspan color="#555555" fontSize= "14px" fontWeight="600" data="Customer Ref. No.: " />
                    <Headspan color="#4BA7DD" fontSize= "14px" fontWeight="600" data={imQuote.customerReferenceNum}/>
                </div>
                        <br />
                        
                        
                <section class="section">
                    <div style={{marginTop:props.view=="view"?"10px":""}}>
                    <Card>
                        <div style={{display:"flex"}}>
                            {!isMailBody?<span><img src={icbaselinerequestquote}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data=" Quotation Details"/>
                        </div>
                        <div className="table-container">
                        <table style={{border:"none", width:"100%"}}>
                            <tbody style={{border:"none"}}>
                                <QuoteDetails rec={rec}/>
                            </tbody>
                        </table>
                        </div>
                    </Card>
                    {
                        (rec1.length>0)?<>
                        <div style={{marginTop:"10px"}}>
                        <Card>
                        <div style={{display:"flex"}}>
                            {!isMailBody?<span><img src={icbaselinerequestquote}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data={quoteDataRec.shipmentType.indexOf("Air")!=-1?" Airline Details":" Carrier Details"}/>
                        </div>
                        {
                                    rec1.map((e,i)=>{
                                        return <><div className="table-container">
                        <table style={{border:"none", width:"100%"}}>
                            <tbody style={{border:"none"}}>
                                <QuoteDetails rec={e}/>
                                </tbody>
                        </table>
                        </div>
                        {
                            (rec1.length>1 && i!=rec1.length-1)?<hr className="m-0"/>:""
                          }</>
                        })
                    }
                    </Card></div>
                        </>:""
                    }
                    {
                        (!isMailBody)?<VehicleViewv3 vehicleDetails={quoteDataRec.vehicleDetails} />:""
                    }
                        
                        {/* {
                            (!isMailBody && quoteDataRec.consolidatorList != null && quoteDataRec.consolidatorList?.length !== 0 && quoteDataRec.shipmentType.toLowerCase().includes('lcl')) && <>
                                <div style={{marginTop:"10px"}}>
                                <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Consolidators"/>
                                    <table style={{border:"none", marginTop:"5px"}}>
                                        <tbody style={{border:"none"}}>
                                            <ConsolidatorView rec={quoteDataRec}/>
                                        </tbody>
                                    </table>
                                </Card>
                                </div>
                            </>
                        } */}
                        {
                            (quoteDataRec.shipmentType.indexOf('FCL') >= 0) ?
                            <div style={{marginTop:"10px"}}>
                                <Card>
                                {!isMailBody?<span><img src={containerdetail}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data=" Container Requirements"/>
                                <ContainerView rec={containerStore.list}/>
                                </Card>
                                </div>
                                 :
                                <></>
                        }
                        {((Utils.displayNonStackable(imQuote.shipmentType, imQuote.shipmentScope) && QuotationUtils.hasCargoDetail())||displayCargo4fcl) ?
                            <div style={{marginTop:"10px"}}>
                            <Card>
                            {!isMailBody?<span><img src={cargoDetail}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data={Utils.labelForOutGauge1(quoteDataRec,containerStore.list)?" Cargo Details for Out-Gauge Containers":" Cargo Details"}/>
                            <CargoView rec={quoteDataRec} displayCargo4fcl={displayCargo4fcl}/>
                            </Card>
                            </div>
                             :
                            <></>
                        }
                        <div style={{marginTop:"10px"}}>
                        <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Charge Limit"/>
                                    {chargesStore1.chargelimit.length>0 && <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    <thead>
                        <tr style={{ fontWeight:"900",border:"solid 0.5px #D4D4D4"}}>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Origin Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Destination Country</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POL</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>POD</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Rate Type</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Percentage</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value</th>
                        <th style={{color:process.env.REACT_APP_ENTERPRISE_COLOUR, padding:"10px"}}>Reduction Value Currency</th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                chargesStore1.chargelimit.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"originCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"destinationCountry")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pol")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"pod")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"rateType")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionPercentage")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValue")}</td>
                                <td style={{color:"#555555", padding:"10px"}}>{getlcv(e,"reductionValueCurrency")}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>}
                        <div className="table-container">
                                    <table style={{border:"none", width:"100%"}}>
                    
                        <tbody>
                            {
                                chargesStore1.limiterrors.map(e=>{
                                    return <tr style={{border:"solid 0.5px #D4D4D4"}}>
                                <td style={{color:"#555555", padding:"10px"}}>{e}</td>
                            </tr>
                                })
                            }
                        </tbody>
                        </table>
                        
                        </div>
                                    </Card>
                       </div>
                        {
                            (quoteDataRec.shipmentType.indexOf('LCL') >= 0) ?
                            <>
                             <div style={{marginTop:"10px"}}>
                            <Card>
                                {imQuote.quoteStatus == "PENDING" && <div className='column is-12' style={{padding:"0",textAlign:"right"}}>
                                                                    <button className="button is-info is-inverted is-large"  onClick={()=>{
                                                                        editrequestapprovalStore.list = JSON.parse(JSON.stringify([]))
                                                                        editrequestapprovalStore.pkb = JSON.parse(JSON.stringify([]))
                                                                        editrequestapprovalStore.rebate = JSON.parse(JSON.stringify([]))
                                                                        setOpenChargeModel(true)
                                                                    }}><span className="icon"><i className="fas fa-pen-to-square fas fa-lg "></i></span></button>
                                                                </div>}
                            <Columns>
                                            <Col6>
                                                <LCLChargesViewRequestApproval isMailBody={isMailBody} totalcurrency={configStore.totalcurrency} data={chargesStore1.list} chargeType="Charge List"/>
                                                {(RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.REBATE) && chargesStore1.nomrg_rebate!=undefined && chargesStore1.nomrg_rebate.length>0) && <LCLChargesViewRequestApproval isMailBody={isMailBody} totalcurrency={configStore.totalcurrency} data={chargesStore1.nomrg_rebate} chargeType="Rebate List"/>}
                                            </Col6>
                                            <Col6>
                                               <LCLChargesViewRequestApproval isMailBody={isMailBody} totalcurrency={configStore.totalcurrency} data={chargesStore1.list1} chargeType="Revised List"/>
                                               {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.REBATE) && chargesStore1.rebate && <LCLChargesViewRequestApproval isMailBody={isMailBody} totalcurrency={configStore.totalcurrency} data={chargesStore1.rebate} chargeType="Rebate List"/>}
                                               {RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.PKB) &&chargesStore1.pkb && <LCLChargesViewRequestApproval isMailBody={isMailBody} totalcurrency={configStore.totalcurrency} data={chargesStore1.pkb} chargeType="Freight Commission List"/>}
                                            </Col6>
                                        </Columns>
                            </Card>
                            </div>
                            </>
                                 :
                                <></>
                        }
                        {
                            (quoteDataRec.shipmentType.indexOf('FCL') >= 0) &&
                            <div style={{marginTop:"10px"}}>
                                {imQuote.quoteStatus == "PENDING" && <div className='column is-12' style={{padding:"0",textAlign:"right"}}>
                                    <button className="button is-info is-inverted is-large" onClick={()=>{
                                        setOpenChargeModel(true)
                                    }}><span className="icon"><i className="fas fa-pen-to-square fas fa-lg "></i></span></button>
                                </div>}
                                <FCLChargesView list={editrequestapprovalStore.quote?.chargesList} containerList={containerStore.list} heading="Charge List" />
                                {editrequestapprovalStore.quote?.mrg_chargesList?.length > 0 &&
                                    <div style={{marginTop:"10px"}}>
                                        <FCLChargesView list={editrequestapprovalStore.quote.mrg_chargesList} containerList={containerStore.list} heading="Revised List" />
                                    </div>}
                            </div>
                        }


                        {(imQuote.shipmentType.indexOf("LCL") >= 0 && quoteTC.some(e => e.trim().length > 0))?<>
                            {
                            (!isMailBody) ?
                                <>
                                <div style={{marginTop:"10px"}}>
                                <Card>
                                    {!isMailBody?<span><img src={carbonrulefilled}/></span>:<></>}<Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Terms & Condition"/>
                                    <ol style={{paddingLeft:'30px',paddingBottom:'10px'}}>
                                        {
                                            quoteTC.filter(e => e.trim().length > 0).map((e, i) => <li key={i}>{e}</li>)
                                        }
                                    </ol>
                                </Card>
                                </div>
                                </> :
                                <>
                                <div style={{marginTop:"10px"}}>
                                <Card>
                                    <Headspan color="#00000" fontSize= "14px" fontWeight="900" data="Terms and Conditions apply"/>
                                </Card>
                                </div>
                                </>
                        }
                        </>:""}
                        


                    </div>
                </section>
                {
                    (RoleUtils.isUserAuthorized(PERMISSIONS_NEW.RATE_REQUEST_APPROVAL.APPROVE_REJECT) && imQuote.quoteStatus == "PENDING") && <>
                    <hr />
                          <Columns>
                            <Col12>
                            
                              <div
                                className="field is-grouped"
                                style={{ display: "flex", justifyContent: "flex-start" }}
                              >
                                <div className="control">
                                  <button
                                    className="button"
                                    style={{
                                      backgroundColor:
                                        process.env.REACT_APP_ENTERPRISE_COLOUR_BUTTON,
                                      color: "#fff",
                                    }}
                                    onClick={async (e) => {
                                      setActionStr("approve")
                                      setActionmodal(true)
                                    }}
                                  >
                                    Approve
                                  </button>
                                </div>
                                
                                <div className="control">
                                  <button
                                    class="button is-danger"
                                    onClick={() => {
                                      setActionStr("reject")
                                      setActionmodal(true)
                                    }}
                                  >
                                    Reject
                                  </button>
                                </div>
                              </div>
                            </Col12>
                          </Columns>
                    </>
                }
            </body>
        </>
    )
}